<template>
  <div class="bg-white bet-slip-selection position-relative d-flex" v-if="selection">
    <div class="checkbox-wrapper" v-if="showCheckbox">
      <custom-checkbox
        v-model="isCheckedModel"
        :value="isChecked"
        :disabled="disabledCheckbox"
        @change="$emit('lineChecked', $event)"
      ></custom-checkbox>
    </div>
    <div class="w-100">
      <div class="bet-slip-line-subheader m-0 bg-white">
        <div class="title d-flex flex-grow-1 flex-column">
          <div class="bold-title d-flex w-100 align-items-baseline">
            <div class="flex-grow-1 bet-first-title text-uppercase">
              {{ checkSpreadPk(selection, selection.OutComeDescription) }}
            </div>
            <div class="d-flex">
              <bet-slip-odds
                class="bet-slip-odd"
                :spread="selection.Point"
                :odds="selection.Odd"
                :wait_for_accept="selection.wait_for_accept"
                :changed_type="selection.changed_type"
                :line="selection"
              ></bet-slip-odds>

              <button
                class="btn line-actions-btn border-0 d-flex align-items-center remove-bet-icon-btn"
                :class="{
                  'is-electron': $isElectron,
                }"
                type="button"
                @click="$emit('onRemove')"
              >
                <i class="icon icon-times"></i>
              </button>
            </div>
          </div>
          <div class="sub-text-color d-flex" style="width: 90%">
            <div class="flex-grow-1">{{ selection.MarketDescription }}</div>
          </div>
          <div class="sub-text-color" style="margin-right: 35px">
            <span v-if="isLive(selection.OutComeId)" class="d-inline-block mr-1">
              <live-icon></live-icon>
            </span>
            {{ selection.GameDescription }}
          </div>
        </div>
      </div>
      <div class="bet-slip-line p-0 pt-2 pb-1" v-if="hasDefaultSlot && !selection.wait_for_accept">
        <slot></slot>
      </div>
      <!-- <div v-if="showBuyPoints && selection.AvailableBuyPoints && selection.AvailableBuyPoints.length > 0 && !selection.wait_for_accept">
        <buy-points-select :line_selection="selection" @change="$emit('onBuyPointChange')"></buy-points-select>
      </div> -->
      <div
        v-if="
          !isLive(selection.OutComeId) &&
          selection.PitcherOptions &&
          selection.PitcherOptions.length > 0 &&
          !selection.wait_for_accept
        "
      >
        <pitcher-options-select :line_selection="selection"></pitcher-options-select>
      </div>
    </div>
  </div>
</template>

<script>
import BetSlipOdds from './BetSlipOdds';
import BuyPointsSelect from './BuyPointsSelect';
import PitcherOptionsSelect from './PitcherOptionsSelect';
import LiveIcon from './LiveIconBetSlip';
import { mapActions } from 'vuex';
import CustomCheckbox from '@/components/shared/CustomCheckbox';
import { isLive } from '@/views/sports/components/bet-slip/check-bets';
import snq from 'snq';
import { trim } from 'lodash';
import { getBetDescription } from './getBetDescription';
import { parseBetErrorMessage,checkSpreadPk } from './bet-slip-utils';

export default {
  props: ['selection', 'parentBetType', 'isChecked', 'showCheckbox', 'disabledCheckbox', 'showBuyPoints'],
  components: {
    CustomCheckbox,
    BetSlipOdds,
    BuyPointsSelect,
    PitcherOptionsSelect,
    LiveIcon,
  },
  data() {
    return {
      isCheckedModel: null,
      isAccepted: false,
    };
  },
  computed: {
    hasDefaultSlot() {
      return !!this.$slots.default;
    },
    tryGetGameDescription() {
      return getBetDescription(this.selection);
    },
  },
  methods: {
    parseBetErrorMessage,
    checkSpreadPk,
    isLive,
    ...mapActions('betSlip', ['acceptOddChange']),
    tryAcceptOddChange(selection) {
      this.acceptOddChange(selection.selection_identifier);
      this.$emit('accept');
      this.isAccepted = true;
      setTimeout(() => {
        this.isAccepted = false;
      }, 3000);
    },
  },
  mounted() {
    this.isCheckedModel = this.isChecked;
  },
  watch: {
    selection: {
      handler(val) {
        if (val.wait_for_accept === false) {
          this.$emit('accept');
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.bet-slip-selection {
  .bet-slip-form-control {
    height: 32px;
  }
}

@media (max-width: 767px) {
  .line-header {
    .title {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
  }
}

.remove-bet-icon-btn {
  padding: 0;
  width: 22px !important;
  height: 22px !important;
  border-radius: 4px;
  margin-bottom: 0 !important;

  &.is-electron {
    .icon {
      color: #555;
    }
  }

  .remove-bet-icon {
    position: relative;
    width: 11.4px;
    background: #f4f4f4;
    display: flex;

    .first {
      position: absolute;
      width: 11.4px;
      height: 1.42px;
      left: 0;

      background: #747474;
      transform: rotate(-45deg);
      display: inline-block;
    }

    .second {
      position: absolute;
      width: 11.4px;
      height: 1.42px;
      left: 0;

      background: #747474;
      transform: rotate(45deg);
      display: inline-block;
    }
  }
}

.bet-slip-odd {
  text-align: right;
  background: var(--color4);
  border-radius: 4px;
  margin-right: 7px;
  height: 22px !important;
  line-height: 22px;
  display: block;

  .odds {
    font-size: 13px;
    padding-left: 10px;
    padding-right: 10px;
    position: relative;
    color: #495057;
  }
}
.sub-text-color {
  color: #495057;
}
.bet-first-title {
  font-size: 13px !important;
  color: #070a14 !important;
}
</style>
